import AddPropertyFormTab from './AddPropertyFormTab/AddPropertyFormTab';
import PropertyCardLayoutTab from './PropertyCard/PropertyCardLayoutTab';
import SearchFormTab from './SearchFormTab/SearchFormTab';
import SinglePropertyLayoutTab from './SinglePropertyLayoutTab/SinglePropertyLayoutTab';

export {
    AddPropertyFormTab, PropertyCardLayoutTab,
    SearchFormTab, SinglePropertyLayoutTab
};

